import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { DeslocamentoTiposApiService } from "./deslocamento-tipos-api.service";
import { DeslocamentoTiposService } from "./deslocamento-tipos.service";

@NgModule({
  imports: [
    SharedModule
  ],
  providers:[
    DeslocamentoTiposApiService,
    DeslocamentoTiposService
  ],
  declarations: []
})
export class DeslocamentoTiposModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamento-tipos/deslocamento-tipos.module.ts
 **/